import { BasicResponsiveImage, Box, BulletListContent, Li, Typography, Ul } from '@vp/swan';
import { CloudinaryImagePresenter } from '@99designs/feature-design-services-landing';

export type OptionDescriptionProps = {
    title: string;
    heroImage: string;
    content: string[];
    inclusions: string[];
};

export function OptionDescription({
    title,
    content,
    inclusions,
    heroImage,
}: OptionDescriptionProps) {
    return (
        <Box mb={8}>
            <CloudinaryImagePresenter
                render={(props) => (
                    <BasicResponsiveImage aspectRatio={2 / 3} as="picture">
                        <img src={props.src} srcSet={props.srcSet} alt="" role="presentation" />
                    </BasicResponsiveImage>
                )}
                imagePath={heroImage}
                width={376}
            />

            <Typography fontSkin="title-subsection" mb={4} mt={5}>
                {title}
            </Typography>
            {content.map((line) => (
                <Typography key={line} mb={4}>
                    {line}
                </Typography>
            ))}
            <Ul aria-labelledby="inclusions-list" skin="checkmark">
                {inclusions.map((inclusion) => (
                    <Li key={inclusion}>
                        <BulletListContent>{inclusion}</BulletListContent>
                    </Li>
                ))}
            </Ul>
        </Box>
    );
}
